import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

export default function AdditionalInformationSumary() {
  const { watch } = useFormContext();

  return (
    <>
      <div className="mb-4 font-weight-bold">
        <FormattedMessage id="general.additionalInformation" defaultMessage="Additional Information" />
      </div>

      <div className="font-b3 space-y-2">
        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quote.quoteTitle" defaultMessage="Quote title" />
          </Col>
          <Col>{watch("additional_information.title")}</Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="tracking.trackingNumber" defaultMessage="Tracking number" />
          </Col>
          <Col>{watch("additional_information.tracking_number")}</Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="general.additionalComments" defaultMessage="Additional comments" />
          </Col>
          <Col>{watch("additional_information.comments")}</Col>
        </Row>
      </div>
    </>
  );
}
